import { postWindowBridge } from '@/utils/windowBridge'
import { LOG_SOURCES } from '#shared/constant/log'
import { jsonParse } from '#shared/utils/jsonParse'

interface ShareContent {
  subject: string
  bodyText: string
}

type ShareActionDetail = {
  Key: string
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      /* eslint @typescript-eslint/no-explicit-any: 0 */
      onRequestAppAction(event: MessageEvent<any>, contents: ShareContent) {
        if (typeof event.data === 'string') {
          // 受信元とのインターフェース定義に基づき data 配列の先頭にはアクション詳細文字列が返る前提。
          // jsonParse の戻り値は any のため、null 判定に必要な null を含めてこの定数が持つべき期待のデータ構造へアサーションする。
          const parsedArrayData = jsonParse(
            event.data,
            LOG_SOURCES.REQUEST_SHARE_ACTION
          ) as string[] | null

          if (parsedArrayData === null) return

          if (parsedArrayData.length == 0 || !parsedArrayData[0]) {
            return
          }

          // 受信元とのインターフェース定義に基づきアクション詳細は Key を持つ前提。
          // jsonParse の戻り値は any のため、null 判定に必要な null を含めてこの定数が持つべき期待のデータ構造へアサーションする。
          const parsedDetailData = jsonParse(
            parsedArrayData[0],
            LOG_SOURCES.REQUEST_SHARE_ACTION
          ) as ShareActionDetail | null
          if (parsedDetailData === null) return

          if (parsedDetailData['Key'] != 'share') {
            return
          }
        } else {
          return
        }
        // アプリ側にシェアアクションを実行
        postWindowBridge('requestShareContents', JSON.stringify(contents))
      },
    },
  }
})
